<template>
  <div>
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="green"
    ></v-progress-circular>
    <div v-else id="paypal-button-container"></div>
  </div>
</template>

<script>
import { loadScript } from '@paypal/paypal-js';
import Axios from 'axios';
import { mapState } from 'vuex';
import { paypalConfig, cloudFunctions } from '../../config.js';
import { db } from '@/db';

export default {
  name: 'paypal-standard',

  props: {
    payButtonEnabled: {
      type: Boolean,
      default: false,
    },
    orderedItem: {
      type: Object,
      default: () => {},
    },
    customerData: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      paypay: null,
      loading: false,
    };
  },

  computed: {
    ...mapState(['userType', 'user_data']),
  },

  mounted() {
    loadScript({
      clientId: paypalConfig.clientId,
      currency: 'EUR',
      components: 'buttons,funding-eligibility',
      vault: true,
      intent: 'subscription',
    })
      .then((paypal) => {
        const ordered = this.orderedItem;
        const customer = this.customerData;
        const emit = this.emitPaymentCompleted;
        this.createButton(emit, paypal, paypal.FUNDING.PAYPAL, ordered, customer);
      })
      .catch((error) => {
        console.log('failed to load Paypal SDK', error);
      });
  },

  methods: {
    emitPaymentCompleted(subscription) {
      this.$emit('payment-successful', {
        paidPlan: this.orderedItem,
        subscription,
        paidBy: 'paypal',
        source: 'paypal-subscription',
      });
    },

    createButton(emit, paypal, fundingSource, ordered, customer) {
      const config = {
        fundingSource,
        createSubscription() {
          return Axios({
            url: `${cloudFunctions}/paypalCreateSubscription`,
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
            data: JSON.stringify({ orderedItem: ordered, customerData: customer }),
          })
            .then((response) => response.data)
            .then((order) => order.id);
        },
        // Finalize the transaction after payer approval
        onApprove(data) {
          console.log('subscription paypal', data);
          const subscription = {
            subscription: data,
            priceId: ordered.paypalId,
          };

          // this.onSubscriptionComplete(subscription);
          // todo: add subscription to user like in onSubscriptionComplete
          // const transaction = orderData.purchase_units[0].payments.captures[0];
          emit(subscription);
        },
      };

      const button = paypal.Buttons(config);
      if (button.isEligible()) {
        button.render('#paypal-button-container');
      }
    },
  },
};
</script>
